import { API_BASE_URL } from "@/libs/apis/commons";
import { PRODUCTS } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { logger } from "@/libs/utils";
import { makeApiProductCall } from "@/src/services/api/getProductData";
import { QueryClient } from "@tanstack/react-query";
import axios from "axios";
import { FormattedTokenAttributeRarity, TokenAttributeRarity } from "./types";

// this uses fetch instead of prefetch - be sure you need to wait on the data before using this
export const fetchProductDataForPrimarySale = async (
  queryClient: QueryClient,
  collectionSlug: string,
  productSlug: string,
  isPublic: boolean,
  axiosConfig = {},
) => {
  return await queryClient.fetchQuery(
    [PRODUCTS, productSlug, isPublic ? "public" : "private"],
    async () =>
      await makeApiProductCall(
        collectionSlug,
        productSlug,
        isPublic,
        axiosConfig,
      ).catch((e) => {
        logger.debug(e);
        return { product: { saleWindowsCollection: { items: [] } } };
      }),
    { retry: false },
  );
};

export const getTokenAttributePercentApiUrl = (
  tokenId: string,
  chainId: number,
  contractAddress: string,
) =>
  `${API_BASE_URL}/collections/${chainId}/${contractAddress}/${tokenId}/attributes-rarity`;

export const formatTokenAttributeData = (data: TokenAttributeRarity[]) => {
  return data.reduce((acc, currVal) => {
    return {
      ...acc,
      [currVal.traitType]: currVal,
    };
  }, {}) as FormattedTokenAttributeRarity;
};

export const makeTokenAttributeRarityApiCall = async (
  tokenId: string,
  chainId: number,
  contractAddress: string,
) =>
  await axios
    .get(getTokenAttributePercentApiUrl(tokenId, chainId, contractAddress))
    .then(({ data }: { data: TokenAttributeRarity[] }) =>
      formatTokenAttributeData(data),
    );
